import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, GeneralConfigType, KeyValueSetInt, KeyValueSet, LocalService, Status, TriggeredEvent, KeyValueSetsInt, ReceiptOptionContains, ReceiptType } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-options-html',
  templateUrl: './receipt-options-html.component.html',
  styleUrl: './receipt-options-html.component.scss'
})
export class ReceiptOptionsHtmlComponent {
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["seller", "common", "receipt"];
  elementIds: any; htmlId: string = '';

  @Input() businessId: string = ''; searchKey = ''; @Input() receiptType: ReceiptType = ReceiptType.None;
  sourcerReceiptOptions: KeyValueSet[]; receiptOptions: KeyValueSet[]; currentReceiptHtml: KeyValueSetsInt[];
  maxBodyHeight = 0; isShowRawCode = false; currentReceiptHtmlJson: string; expandedKey: string = ''; isShowOnlyFilledHtml = false;


  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public billingManagementService: BillingManagementService, public configurationManagementService: ConfigurationManagementService, private router: Router) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_search_key: 'txt_search_key_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (!this.localService.receiptOptions) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ReceiptOption, true).subscribe(result => {
        this.localService.receiptOptions = result;
        this.sourcerReceiptOptions = result;
        this.onLoad();
      });
    } else {
      this.sourcerReceiptOptions = this.localService.receiptOptions;
      this.onLoad();
    }
  }


  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  ngOnChanges(): void {

  }

  onLoad() {
    if (this.sourcerReceiptOptions && !this.currentReceiptHtml) {
      this.sourcerReceiptOptions = this.localService.Sort(this.sourcerReceiptOptions, true, "value");
      this.billingManagementService.getReceiptOptionsHtml(this.receiptType, this.businessId).subscribe(result => {
        this.currentReceiptHtml = result;

        this.sourcerReceiptOptions.forEach(item => {
          //item.value = '(' + item.key + ') ' + item.value;
          let currentHtml = this.currentReceiptHtml.find(x => x.key == parseInt(item.key));
          if (!currentHtml) {
            this.currentReceiptHtml.push({
              key: parseInt(item.key),
              value: '',
              values: [],
              isSelected: false
            } as KeyValueSetsInt);
          }
        });

        this.receiptOptions = this.sourcerReceiptOptions.map(function (result) {
          return {
            key: result.key,
            value: result.value
          } as KeyValueSet;
        });
      });
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        if (this.sourcerReceiptOptions) {
          let searchKey = this.searchKey.trim().toLowerCase();
          let items = searchKey != '' ? this.sourcerReceiptOptions.filter(x => x.key.indexOf(searchKey) > -1 || x.value.toLowerCase().indexOf(searchKey) > -1 || (x.s_value && x.s_value.indexOf(searchKey) > -1)) : this.sourcerReceiptOptions;
          this.receiptOptions = items.map(function (result) {
            return {
              key: result.key,
              value: result.value,
              isSelected: result.isSelected
            } as KeyValueSet;
          });

          this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
        }
      } break;
      case 2: {
        //Save
        if (this.isShowRawCode) {
          this.currentReceiptHtml = JSON.parse(this.currentReceiptHtmlJson);
        }
        this.billingManagementService.saveReceiptOptionsHtml(this.receiptType, this.businessId, this.currentReceiptHtml).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onClose.emit({ event: TriggeredEvent.Close });
          }
        });
      } break;
      case 3: {
        //Update source
        this.sourcerReceiptOptions.find(x => x.key == key).isSelected = this.receiptOptions.find(x => x.key == key).isSelected;
      } break;
      case 4: {
        //On/Off code
        this.isShowRawCode = !this.isShowRawCode;
        if (this.isShowRawCode) {
          this.currentReceiptHtmlJson = JSON.stringify(this.currentReceiptHtml);
        } else {
          this.currentReceiptHtml = JSON.parse(this.currentReceiptHtmlJson);
        }
      } break;
      case 5: {
        if (this.businessId) {
          this.router.navigate(['/biz-receipt-custom' + this.localService.basicParamsString, 0, 0, 2, this.businessId]);
        } else {
          this.router.navigate(['/general-configuration' + this.localService.basicParamsString, 0, 0, 2]);
        }
      } break;
      case 6: {
        //Show or hide more
        this.expandedKey = this.expandedKey == key ? '' : key;
        if (this.expandedKey) {
          this.onEnsureReceiptOptionsContains(this.expandedKey);
        }
      } break;
      case 7: {
        //Enable or disable loop mode
        const html = this.currentReceiptHtml.find(x => x.key == parseInt(key));
        if (html) {
          html.isSelected = html.isSelected ? false : true;
        } else {
          html.isSelected = true;
        }
      } break;
      case 8: {
        this.onParseOptionsContains(key);
      } break;
      case 9: {
        const htmlKeys = this.localService.Sort(this.currentReceiptHtml.map(x => x.key), true, undefined, true);
        htmlKeys.forEach(htmlKey => {
          this.onParseOptionsContains(htmlKey);
        });
      } break;
    }
  }

  onParseOptionsContains(key: string) {
    this.onEnsureReceiptOptionsContains(key);
    const containsOptions = Object.keys(ReceiptOptionContains).map(x => parseInt(x)).filter(x => x);
    const prefix = 'ReceiptOption';
    const receiptOptionKeys = this.localService.Sort(this.sourcerReceiptOptions.map(x => parseInt(x.key)), true, undefined, true);
    containsOptions.forEach(optionContain => {
      let html = this.currentReceiptHtml.find(x => x.key == parseInt(key));
      let htmlOptionContains = html.values.find(x => x.key == optionContain);
      let temp: number[] = [];
      receiptOptionKeys.forEach(receiptOptionKey => {
        const searchTerm = '#' + prefix + (optionContain != ReceiptOptionContains.Option ? this.localService.onGetReceiptOptionContainsText(optionContain) : '') + '-' + receiptOptionKey + '#';
        if (html.value.indexOf(searchTerm) > -1) {
          temp.push(receiptOptionKey);
        }
      });
      htmlOptionContains.value = temp.join(',');
    });
  }

  onEnsureReceiptOptionsContains(key: string) {
    const containsOptions = Object.keys(ReceiptOptionContains).map(x => parseInt(x)).filter(x => x);
    let html = this.currentReceiptHtml.find(x => x.key == parseInt(key));
    if (!html.values || html.values.length != containsOptions.length) {
      if (!html.values) {
        html.values = [] as KeyValueSetInt[];
      }
      containsOptions.forEach(optionContain => {
        const isOptionContainAvailable = html.values.find(x => x.key == optionContain);
        if (!isOptionContainAvailable) {
          html.values.push({
            key: optionContain,
            value: ''
          } as KeyValueSetInt);
        }
      });
    }
  }

  isLoop(key: string): boolean {
    let rtn = false;
    const html = this.currentReceiptHtml.find(x => x.key == parseInt(key));
    if (html) {
      rtn = html.isSelected ? true : false;
    }
    return rtn;
  }

  isHtmlAvailable(key: string): boolean {
    let rtn = false;
    const html = this.currentReceiptHtml.find(x => x.key == parseInt(key));
    if (html) {
      rtn = html.value ? true : false;
    }
    return rtn;
  }

  onGetReceiptTypeName(): string {
    return ReceiptType[this.receiptType];
  }
}
